import React from 'react';
import Divider from '@material-ui/core/Divider';
import ListSubheader from '@material-ui/core/ListSubheader';
import MenuItem from '@material-ui/core/MenuItem';
import { USERS_MENU_SECTIONS } from './index';

interface RenderArgs {
    selectedUser: any;
    onSelect: (value: string) => void;
    showApproveDisabledHint?: boolean;
}

const headerBaseStyle: React.CSSProperties = {
    fontSize: 11,
    fontWeight: 600,
    lineHeight: '24px',
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    paddingTop: 4,
    paddingBottom: 0
};

const dangerColor = '#c62828';

export function renderUserMenuItems({
    selectedUser,
    onSelect,
    showApproveDisabledHint = false
}: RenderArgs): React.ReactNode[] {
    const nodes: React.ReactNode[] = [];

    USERS_MENU_SECTIONS.forEach((section, sIdx) => {
        if (sIdx > 0) {
            nodes.push(<Divider key={`um-divider-${sIdx}`} />);
        }
        nodes.push(
            <ListSubheader
                key={`um-header-${sIdx}`}
                disableSticky
                style={{
                    ...headerBaseStyle,
                    color: section.danger ? dangerColor : '#888'
                }}
            >
                {section.label}
            </ListSubheader>
        );
        section.items.forEach((item) => {
            const isApprove = item.value === 'approve';
            const disabled =
                showApproveDisabledHint &&
                isApprove &&
                !selectedUser?.is_profile_complete;
            nodes.push(
                <MenuItem
                    key={item.value}
                    onClick={() => onSelect(item.value)}
                    disabled={disabled}
                    style={
                        section.danger ? { color: dangerColor } : undefined
                    }
                >
                    {item.title}
                </MenuItem>
            );
        });
    });

    return nodes;
}
